export default __webpack_public_path__ + "static/media/astore.f2628736.svg";